(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["opd-review-headings"] && !Shopify.designMode) return;
  try {
    (function () {
  'use strict';

  var selector = 'h1[data-fera-widget-heading], [data-fera-container="store_customer_media"] h1';

  function normalizeHeading(heading) {
    var replacement = document.createElement('h2');
    Array.prototype.forEach.call(heading.attributes, function (attribute) {
      replacement.setAttribute(attribute.name, attribute.value);
    });
    var style = window.getComputedStyle(heading);
    ['font-size', 'line-height', 'font-weight', 'letter-spacing', 'margin-top', 'margin-bottom'].forEach(function (property) {
      replacement.style.setProperty(property, style.getPropertyValue(property));
    });
    while (heading.firstChild) replacement.appendChild(heading.firstChild);
    heading.replaceWith(replacement);
  }

  function normalizeWithin(root) {
    if (root.nodeType !== 1) return;
    if (root.matches(selector)) normalizeHeading(root);
    root.querySelectorAll(selector).forEach(normalizeHeading);
  }

  function start() {
    normalizeWithin(document.body);
    var observer = new MutationObserver(function (records) {
      records.forEach(function (record) {
        record.addedNodes.forEach(normalizeWithin);
      });
    });
    observer.observe(document.body, { childList: true, subtree: true });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', start, { once: true });
  } else {
    start();
  }
}());
  } catch(e) { console.error(e); }
})();

})();
